import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import deselectBundleProductReducer from './reducer/deselectBundleProductReducer';
import selectBundleProductReducer from './reducer/selectBundleProductReducer';
import setAbstractProductReducer from './reducer/setAbstractProduct';
import setCurrentProductReducer from './reducer/setCurrentProductReducer';
import setForcedPreviewsReducer from './reducer/setForcedPreviewsReducer';
import setPublicAssetImageDataReducer from './reducer/setPublicAssetImageDataReducer';
import setPublicAssetProductDataReducer from './reducer/setPublicAssetProductDataReducer';
import setMoreArtPrintsReducer from './reducer/setMoreArtPrintsReducer';
import setSelectedBundleProducts from './reducer/setSelectedBundleProducts';
import setSimilarImagesReducer from './reducer/setSimilarImagesReducer';
import setInitialCurrentProductReducer from './reducer/setInitialCurrentProductReducer';
import setProductIdReducer from './reducer/setProductIdReducer';
import setSelectedAbstractProductNameReducer from './reducer/setSelectedAbstractProductNameReducer';
import setSelectedAbstractProduct from './reducer/setSelectedAbstractProductReducer';
import setSourceImageId from './reducer/setSourceImageIdReducer';
import { PublicAssetProductState } from './types';
import setLoadingProductsReducer from './reducer/setLoadingProductsReducer';
import setAddingToCartFlowReducer from './reducer/setAddingToCartReducer';
import { AddToCartFlow } from '../product/types';

export const initialState: PublicAssetProductState = {
  publicAssetAbstractProductData: undefined,
  abstractProducts: {},
  selectedAbstractProduct: undefined,
  currentProduct: undefined,
  source: '',
  sourceImageId: '',
  selectedAbstractProductName: '',
  productId: 0,
  moreArtPrints: undefined,
  similarImages: undefined,
  publicAssetImageData: {
    artistName: '',
    designName: '',
    preview: '',
  },
  selectedBundleProducts: [],
  forcedPreviews: {},
  loadingProducts: false,
  addingToCartFlow: AddToCartFlow.idle,
};

export const slice = createSlice({
  name: 'publicAssetProduct',
  initialState,
  reducers: {
    setPublicAssetProductDataAction: setPublicAssetProductDataReducer,
    setAbstractProductAction: setAbstractProductReducer,
    setSelectedAbstractProductAction: setSelectedAbstractProduct,
    setCurrentProductAction: setCurrentProductReducer,
    setSourceImageIdAction: setSourceImageId,
    setInitialCurrentProductAction: setInitialCurrentProductReducer,
    setSelectedAbstractProductNameAction: setSelectedAbstractProductNameReducer,
    setProductIdAction: setProductIdReducer,
    setSimilarImagesAction: setSimilarImagesReducer,
    setMoreArtPrintsAction: setMoreArtPrintsReducer,
    setPublicAssetImageDataAction: setPublicAssetImageDataReducer,
    setForcedPreviewsAction: setForcedPreviewsReducer,
    selectBundleProductAction: selectBundleProductReducer,
    deselectBundleProductAction: deselectBundleProductReducer,
    setSelectedBundleProductsAction: setSelectedBundleProducts,
    setLoadingProductsAction: setLoadingProductsReducer,
    setSourceAction: (state: PublicAssetProductState, action: PayloadAction<string>) => {
      state.source = action.payload;
    },
    setAddingToCartFlowAction: setAddingToCartFlowReducer,
  },
});

export const {
  setPublicAssetProductDataAction,
  setAbstractProductAction,
  setSelectedAbstractProductAction,
  setCurrentProductAction,
  setInitialCurrentProductAction,
  setSourceImageIdAction,
  setSelectedAbstractProductNameAction,
  setProductIdAction,
  setSimilarImagesAction,
  setMoreArtPrintsAction,
  setPublicAssetImageDataAction,
  setForcedPreviewsAction,
  selectBundleProductAction,
  deselectBundleProductAction,
  setSelectedBundleProductsAction,
  setLoadingProductsAction,
  setSourceAction,
  setAddingToCartFlowAction,
} = slice.actions;

const publicAssetProduct = slice.reducer;
export default publicAssetProduct;
